import { EmojiPickerProvider } from '../../../contexts/emoji-picker';
import { useEmojiPicker } from '../../../hooks/useEmojiPicker';

// Requires emoji and setEmoji props (from `useState`)
const EmojiPicker = ({ isDefaultOpen, emoji, setEmoji, children }) => {
  const { isOpen, setIsOpen, listProps, iconProps, triggerProps } =
    useEmojiPicker(emoji, setEmoji, isDefaultOpen);

  return (
    <EmojiPickerProvider
      value={{ isOpen, setIsOpen, listProps, iconProps, triggerProps }}
    >
      {children}
    </EmojiPickerProvider>
  );
};

export default EmojiPicker;
